import React, { Component } from 'react';
import {Dummy} from '../'
import styles from './style.css'
var classNames = require('classnames');

export default class Uso extends Dummy {

    render() {
        let triangleClass = {};
        triangleClass[styles.avar] = (this.getCleanValue(this.props.ps[0]) == 1);
        console.log(triangleClass[styles.avar]);
        return (
            <div id={this.props.div_id} className={styles.wrap}>
                <div className={classNames(styles.triangle,styles[`triangle-${this.props.direction}`], triangleClass)}></div>
                <div className={classNames(styles.uso, styles[this.props.direction])}>
                    <div className={styles.caption}>{this.props.caption}</div>
                </div>
            </div>
        );
    }
}

Uso.propTypes = {
    caption: React.PropTypes.string,
    div_id: React.PropTypes.string,
    direction: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/Uso/index.jsx